<p>view-child-case-study works!</p>
